<div class="page-layout-container">
  <div class="row">
    <h1 class="title">Employees Leaves Calculation Batches</h1>
  </div>

  <div *ngIf="message" class="alert alert-success">{{ messageDesc }}</div>
  <div *ngIf="error" class="alert alert-danger">{{ errorDesc }}</div>
  <div class="row">
    <div class="col-3" style="width: 100%">
      <mat-form-field>
        <mat-label>UnFreeze NConnect TimeSheet</mat-label>
        <input
          matInput
          [matDatepicker]="batchYear"
          [(ngModel)]="selectedYear"
          required
          (dateChange)="checkTimeSheetStatus($event)"
        />
        <mat-datepicker-toggle
          matSuffix
          [for]="batchYear"
        ></mat-datepicker-toggle>
        <mat-datepicker #batchYear></mat-datepicker>
      </mat-form-field>
    </div>
    <div class="col-md-auto" style="text-align: center">
      <button
        mat-button
        [disabled]="true"
        id="yearButton"
        (click)="unFreezeTimeSheet()"
        type="submit"
      >
        UnFreeze NConnect TimeSheet
      </button>
    </div>
  </div>

  <div class="row">
    <div class="col-3" style="width: 100%">
      <mat-form-field>
        <mat-label>Generating RTT Leaves</mat-label>
        <input
          matInput
          [matDatepicker]="batchMonth"
          required
          [(ngModel)]="selectedMonth"
          (dateChange)="fetchMonthlyReport($event)"
        />
        <mat-datepicker-toggle
          matSuffix
          [for]="batchMonth"
        ></mat-datepicker-toggle>
        <mat-datepicker #batchMonth></mat-datepicker>
      </mat-form-field>
    </div>
    <div class="col-md-auto" style="text-align: center">
      <button
        mat-button
        [disabled]="true"
        id="monthButton"
        (click)="triggerRTTLeaves()"
        type="submit"
      >
        Generate Monthly RTT Adv Leaves
      </button>
    </div>
  </div>

  <div class="row">
    <div class="col-3" style="width: 100%">
      <mat-form-field>
        <mat-label>NConnect TS Freeze</mat-label>
        <input
          matInput
          [matDatepicker]="selectedFreezeMonth"
          (dateChange)="fetchFreezeTimeSheetReport($event)"
        />
        <mat-datepicker-toggle
          matSuffix
          [for]="selectedFreezeMonth"
        ></mat-datepicker-toggle>
        <mat-datepicker #selectedFreezeMonth></mat-datepicker>
      </mat-form-field>
    </div>
    <div class="col-md-auto" style="text-align: center">
      <button
        mat-button
        [disabled]="true"
        id="timeSheetFreezeButton"
        (click)="freezeTimeSheetJob()"
        type="submit"
      >
        Freeze NConnect Timesheet
      </button>
    </div>
    <div class="col-3" style="width: 100%">
      <mat-form-field>
        <mat-label>NEPtune TS Freeze</mat-label>
        <input
          matInput
          [matDatepicker]="selectedNEPtuneMonth"
          (dateChange)="fetchNEPtuneTSReport($event)"
        />
        <mat-datepicker-toggle
          matSuffix
          [for]="selectedNEPtuneMonth"
        ></mat-datepicker-toggle>
        <mat-datepicker #selectedNEPtuneMonth></mat-datepicker>
      </mat-form-field>
    </div>
    <div class="col-md-auto" style="text-align: center">
      <button
        mat-button
        [disabled]="true"
        id="tsNEPtuneFreezeButton"
        (click)="freezeNEPtuneTSJob()"
        type="submit"
      >
        Freeze NEPtune Timesheet
      </button>
    </div>
  </div>

  <div class="row">
    <h1 class="title">Executed Batches Jobs List</h1>
  </div>
  <div>
    <mat-form-field appearance="standard">
      <mat-label>Filter</mat-label>
      <input
        matInput
        (keyup)="applyFilter($event)"
        placeholder="search with Batch Name"
        #input
      />
    </mat-form-field>

    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
      <ng-container matColumnDef="batchJobName">
        <th mat-header-cell *matHeaderCellDef>Batch Job Name</th>
        <td mat-cell *matCellDef="let element">{{ element.batchJobName }}</td>
      </ng-container>

      <ng-container matColumnDef="executionDate">
        <th mat-header-cell *matHeaderCellDef>Execution Date</th>
        <td mat-cell *matCellDef="let element">{{ element.executionDate }}</td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>Status</th>
        <td mat-cell *matCellDef="let element">{{ element.status }}</td>
      </ng-container>

      <ng-container matColumnDef="batchYear">
        <th mat-header-cell *matHeaderCellDef>Executed for Year</th>
        <td mat-cell *matCellDef="let element">{{ element.batchYear }}</td>
      </ng-container>

      <ng-container matColumnDef="batchMonth">
        <th mat-header-cell *matHeaderCellDef>Executed for Month</th>
        <td mat-cell *matCellDef="let element">{{ element.batchMonth }}</td>
      </ng-container>

      <ng-container matColumnDef="batchTriggeredBy">
        <th mat-header-cell *matHeaderCellDef>Batch Triggered By</th>
        <td mat-cell *matCellDef="let element">
          {{ element.batchTriggeredBy }}
        </td>
      </ng-container>

      <ng-container matColumnDef="comments">
        <th mat-header-cell *matHeaderCellDef>Comments</th>
        <td mat-cell *matCellDef="let element">{{ element.comments }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>

    <mat-paginator
      [pageSizeOptions]="[5, 10, 20]"
      showFirstLastButtons
    ></mat-paginator>
  </div>
  <app-progress [loading$]="loading$"> </app-progress>
</div>
